module.exports = __webpack_public_path__ + "static/rakshith_crop-f8fcb2ca92cad8525df39f5f449582cc.jpg";